// components/modals/web-modals/LoginModal.jsx

import { useTranslation } from 'react-i18next';
import BaseModalWeb from './BaseModalWeb';
import LoginComponent from '../../../auth/components/LoginComponent';

const LoginModal = ({ isOpen, onRequestClose, openSignUpModal }) => {
  const { t } = useTranslation();

  return (
    <BaseModalWeb
      isOpen={isOpen}
      onRequestClose={onRequestClose}
      contentLabel="Login Modal"
      className="ReactModal__Content modal--web modal--500px"
      overlayClassName="ReactModal__Overlay modal-overlay--web"
    >
      <h2 style={{ marginTop: 0, textAlign: 'center', color: 'var(--green-darkest)' }}>
        {t('login')}
      </h2>
      <LoginComponent
        onRequestClose={onRequestClose}
        openSignUpModal={openSignUpModal}
      />
    </BaseModalWeb>
  );
};

export default LoginModal;